const GET_AMS_CUSTOMER_INFO = "getAmsCustomerInfo";
const SET_AMS_CUSTOMER_INFO = "setAmsCustomerInfo";
const INIT_PROFILE_INFO = "initProfileInfo";
const GET_VALIDATE_SELF_ASSET = "getValidateSelfAsset";
const GET_VALIDATE_BO_MAX_LOSS_AMOUNT = "getValidateBoMaxLossAmount";
const VALIDATE_BO_MAX_LOSS_AMOUNT = "validateBoMaxLossAmount";
const VALIDATE_SELF_ASSET = "validateSelfAsset";
const SET_ACTIVE_BLOCK= "setActiveBlock";
const SET_ADDITIONAL_MAIL = "setAdditionalMail";
const UPDATE_CUSTOMER_INFO = "updateCustomerInfo";
const GET_ALERT_PASS2_FAIL = "getAlertPass2Fail";
const SET_ALERT_PASS2_FAIL = "setAlertPass2Fail";

export {
    GET_VALIDATE_BO_MAX_LOSS_AMOUNT,
    VALIDATE_BO_MAX_LOSS_AMOUNT,
    GET_VALIDATE_SELF_ASSET,
    VALIDATE_SELF_ASSET,
    INIT_PROFILE_INFO,
    GET_AMS_CUSTOMER_INFO,
    SET_AMS_CUSTOMER_INFO,
    SET_ACTIVE_BLOCK,
    SET_ADDITIONAL_MAIL,
    UPDATE_CUSTOMER_INFO,
    GET_ALERT_PASS2_FAIL,
    SET_ALERT_PASS2_FAIL,
};
